import React, { useEffect, useRef, useState } from 'react'
import findIndex from 'lodash/findIndex'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'
import 'swiper/swiper.scss'
import 'swiper/components/navigation/navigation.scss'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { MaterialsType } from '../../store/tags/tagsTyping'
import paths from '../../paths'
import { useTranslation } from 'react-i18next'
import { disableMenu, enableMenu, initOfSavingPath } from '../../store/common/commonSlice'
import { useInitOfSavingClearPath } from '../../hooks/useBackButton'
import { useDispatch } from 'react-redux'

interface Props {
    list: MaterialsType[]
    photo: MaterialsType
    setForceUpdateList?: React.Dispatch<boolean>
}

SwiperCore.use([Navigation])

const SwiperIndexMaterials: React.FunctionComponent<Props> = ({ list, photo, setForceUpdateList }: Props) => {
    useInitOfSavingClearPath()

    const [t] = useTranslation()
    const history = useHistory()
    const location = useLocation()
    const dispatch = useDispatch()

    const [currentIndex, setCurrentIndex] = useState(findIndex(list, photo))
    const swiper = useRef(null)

    useEffect(() => {
        dispatch(disableMenu())
        return () => {
            dispatch(enableMenu())
        }
    }, [])

    useEffect(() => {
        if (!photo) {
            setCurrentIndex(list.findIndex((item) => item.id == Number(new URLSearchParams(location.search).get('id'))))
        }
    }, [])

    useEffect(() => {
        history.replace(location.pathname + `?id=${list[currentIndex].id}`)
        if (list.length - 2 <= currentIndex && setForceUpdateList) setForceUpdateList(true)
    }, [currentIndex])

    useEffect(() => {
        dispatch(initOfSavingPath(location.pathname + location.search))
    }, [location])

    return (
        <Swiper
            // @ts-ignore
            ref={swiper}
            navigation
            initialSlide={findIndex(list, photo)}
            className="mySwiper"
            onSlideChangeTransitionStart={() => {
                setCurrentIndex(swiper.current.swiper.activeIndex)
            }}
        >
            {list.map((item) => (
                // @ts-ignore
                <SwiperSlide key={item.id || item.url}>
                    <img className="photo" src={item.url} alt="" />
                </SwiperSlide>
            ))}
            <div
                className={'description'}
                onClick={(e) => {
                    e.stopPropagation()
                }}
            >
                <div className="contributorInfo">
                    <div className="avatar">
                        <img src={list[currentIndex].contribution.user.avatar_url} alt="" />
                    </div>
                    <div className="data">
                        <Link
                            to={paths.profile.toPath({
                                nick: list[currentIndex].contribution.user.nick
                            })}
                            className="nick"
                        >
                            {list[currentIndex].contribution.user.nick}
                        </Link>
                        <p>{list[currentIndex].contribution.user.country}</p>
                    </div>
                </div>
                <Link
                    className={'contributionDetails'}
                    onClick={(e) => {
                        e.stopPropagation()
                    }}
                    to={list[currentIndex].page_url}
                >
                    <p>
                        {t('Contribution')}
                        <span className={'contributionNumber'}>{list[currentIndex].contribution.number}</span>
                    </p>
                    <p className={'contributionTitle'}>{list[currentIndex].contribution.title}</p>
                </Link>
            </div>
        </Swiper>
    )
}

export default SwiperIndexMaterials
